class ForgotPasswordUsersController {
    static controller($scope, $state) {
        'ngInject';
        $scope.sref = "public.users.forgot-password";

        $scope.getHref = function(sref) {
          return $state.href(sref);
        }
    };
}

export default ForgotPasswordUsersController.controller;



// WEBPACK FOOTER //
// ./src/users/forgot-password/forgot-password.users.controller.js